import React from 'react';
import PropTypes from 'prop-types';

import ContactPanelRow from 'components/contacts/contact_panel_row';
import EmptyState from 'components/project/empty_state';

export default class ContactList extends React.Component {
  static propTypes = {
    contacts: PropTypes.array,
    showLogTaskModal: PropTypes.func,
    showNewTaskModal: PropTypes.func,
    onAddContactClicked: PropTypes.func,
    onRemoveContact: PropTypes.func.isRequired
  };

  render() {
    if (this.props.contacts.length > 0) {
      return this.props.contacts.map(contact => (
        <ContactPanelRow
          contact={contact}
          key={contact.id}
          onCreateTask={this.props.showNewTaskModal}
          onEditContact={this.props.onAddContactClicked}
          onLogActivity={this.props.showLogTaskModal}
          onRemoveContact={this.props.onRemoveContact}
        />
      ));
    } else {
      return (
        <EmptyState imageSrc="/images/project_empty_states/details.svg" message="No Contacts to display." />
      );
    }
  }
}
